import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";

const ResReservationV2_Success = (props) => {

    const { t } = props

    return (
        <section class="widgets spa-listing spa-details completed">

            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{t(`resReservationV2.success.success_heading`)}</div>
                <div>{t(`resReservationV2.success.success_sub_heading`)}</div>
            </div>

            <section class="widgets">

            <div class="row margin-bottom-2">

					<div class="row">
						<div class="col">
							<div class="detail-body stay-body">
								<form>
									<div class="form-row">
										<p style={{ whiteSpace: "pre-line" }}>{t('resReservationV2.success_message')}</p>
									</div>
								</form>
							</div>
						</div>
					</div>

                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <div class="form-controls">
                            <button class="primary w-100 margin-bottom-1" onClick={() => props.next()}>{t('resReservationV2.okay')}</button>
                        </div>
                    </div>
				</div>
            </section>

        </section>
    )
}

const mapStateToProps = state => {
    return {
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, {})(withTranslation('translations')(ResReservationV2_Success));